import React, { FC } from 'react';

interface Props {
  children: React.ReactNode;
  to: string;
  onClick(): void;
  appDefinitionId: string;
  forceFullPageNavigation: boolean;
  ariaLabel?: string;
  dataHook: string;
}

export const Link: FC<Props> = ({
  children,
  to,
  onClick,
  ariaLabel,
  dataHook,
}) => (
  <a
    target="_top"
    href={to}
    onClick={() => onClick()}
    aria-label={ariaLabel}
    data-hook={dataHook}
  >
    {children}
  </a>
);

export default Link;
